import { Modal, Button, Spin } from "antd";
import { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import "../../../styles/teamMember.scss";
import { useSelector } from "react-redux";
import { CREATING_DOCUMENT_CATEGORY } from "../../../store/document-store/reducer";

import FormCategory from "./formCategory";

const ModalCategories = ({
  form,
  fetchSubData,
  isModalVisible,
  setIsModalVisible,
}) => {
  const [loading, setLoading] = useState(false);
  const { organisationId } = useSelector(({ auth }) => auth.user);

  const [category, setCategory] = useState({
    organisationId: organisationId,
    _id: "new",
    active: true,
  });

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 18, color: "#fff" }} spin />
  );

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    setLoading(true);
    switch (isModalVisible.type) {
      case "Category":
        CREATING_DOCUMENT_CATEGORY(category).then((data) => {
          fetchSubData();
          setTimeout(() => {
            form.setFields([
              {
                name: "employmentTypeId",
                value: data?._id,
              },
            ]);
            setLoading(false);
            setIsModalVisible(false);
          }, 1000);
        });
        break;

      default:
        setLoading(false);
        break;
    }
  };

  const renderType = () => {
    switch (isModalVisible.type) {
      case "Category":
        return <FormCategory category={category} setCategory={setCategory} />;
      default:
        setLoading(false);
        break;
    }
  };

  return (
    <Modal
      title={"Add " + isModalVisible.type}
      visible={isModalVisible}
      onCancel={handleCancel}
      className="modal-sub"
      okText="Add"
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="add"
          type="primary"
          onClick={handleOk}
          style={{ opacity: loading && 0.6 }}
        >
          {loading ? <Spin indicator={antIcon} /> : "Add"}
        </Button>,
      ]}
    >
      {renderType()}
    </Modal>
  );
};

export default ModalCategories;
